module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WATER_ELEMENTAL_STYLE.febe9470.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WATER_ELEMENTAL_STYLE.png
// module id = 1182
// module chunks = 16